import {
  ActionPayload,
  Activity,
  LogExternalWorkoutPayload,
  UpdateExternalWorkoutPayload,
} from 'reducers/activities/types';

export enum FETCH_ACTIVITIES {
  request = 'FETCH_ACTIVITIES_REQUEST',
  success = 'FETCH_ACTIVITIES_SUCCESS',
  failure = 'FETCH_ACTIVITIES_FAILURE',
}

export enum LOG_EXTERNAL_WORKOUT {
  request = 'LOG_EXTERNAL_WORKOUT_REQUEST',
  success = 'LOG_EXTERNAL_WORKOUT_SUCCESS',
  failure = 'LOG_EXTERNAL_WORKOUT_FAILURE',
}

export enum UPDATE_EXTERNAL_WORKOUT {
  request = 'UPDATE_EXTERNAL_WORKOUT_REQUEST',
  success = 'UPDATE_EXTERNAL_WORKOUT_SUCCESS',
  failure = 'UPDATE_EXTERNAL_WORKOUT_FAILURE',
}

export const requestFetchActivities = (payload: ActionPayload) => ({
  type: FETCH_ACTIVITIES.request,
  payload,
});

export const receiveFetchActivities = (payload: ActionPayload) => ({
  type: FETCH_ACTIVITIES.success,
  payload,
});

export const failureFetchActivities = () => ({
  type: FETCH_ACTIVITIES.failure,
});

export const requestLogExternalWorkout = (payload: LogExternalWorkoutPayload) => ({
  type: LOG_EXTERNAL_WORKOUT.request,
  payload,
});

export const receiveLogExternalWorkout = () => ({
  type: LOG_EXTERNAL_WORKOUT.success,
});

export const failureLogExternalWorkout = (error: string) => ({
  type: LOG_EXTERNAL_WORKOUT.failure,
  payload: { error },
});

export const requestUpdateExternalWorkout = (payload: UpdateExternalWorkoutPayload) => ({
  type: UPDATE_EXTERNAL_WORKOUT.request,
  payload,
});

export const receiveUpdateExternalWorkout = (workout: Activity) => ({
  type: UPDATE_EXTERNAL_WORKOUT.success,
  payload: { workout },
});

export const failureUpdateExternalWorkout = (error: string) => ({
  type: UPDATE_EXTERNAL_WORKOUT.failure,
  payload: { error },
});
